import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-dialogdeletekaizenconfirm',
    templateUrl: './dialogdeletekaizenconfirm.component.html',
    styleUrls: ['./dialogdeletekaizenconfirm.component.css'],
    standalone: false
})
export class DialogdeletekaizenconfirmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
